<template>
  <li @click="goToRoom(roomId)" class="list-group-item justify-content-between">
    {{ roomName }}
    <span v-if="roomItemsCount > 0" class="badge badge-default badge-pill">{{ roomItemsCount }}</span>
  </li>
</template>

<script>
export default {
  name: 'RoomListItem',
  props: ['roomId', 'roomName', 'roomItemsCount'],
  methods: {
    goToRoom: function (roomId) {
      this.$store.dispatch('selectRoom', roomId)
        .then(() => {
          this.$router.push({ name: 'room' })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/children/RoomListItem.vue